import { CharacterMetadata } from '@wix/draft-js';
/** Only used to match/cleanup mentions that were not submitted via the mention suggestions popup. Replaces plaintext mentions with entities. */ export const matchMentionsAndAttachEntities = (content)=>{
    let newContent = content;
    const blockMap = newContent.getBlockMap();
    const blocks = blockMap.map((block)=>{
        let newChars = block.getCharacterList();
        let altered = false;
        const updateRangeWithMention = (start, end, newKey)=>{
            newChars = newChars.map((char, i)=>{
                if (start <= i && i < end) {
                    return CharacterMetadata.applyEntity(char, newKey);
                }
                return char;
            });
            altered = true;
        };
        const text = block.getText();
        const re = /@([A-Za-z0-9][A-Za-z0-9-]{1,18}[A-Za-z0-9])/g;
        let matches;
        // tslint:disable-next-line
        while((matches = re.exec(text)) !== null){
            const hasEntity = block.getEntityAt(matches.index);
            if (!hasEntity) {
                newContent = newContent.createEntity('mention', 'IMMUTABLE', {
                    mention: {
                        name: matches[0]
                    }
                });
                const entityKey = newContent.getLastCreatedEntityKey();
                updateRangeWithMention(matches.index, matches.index + matches[0].length, entityKey);
            }
        }
        return altered ? block.set('characterList', newChars) : block;
    });
    return newContent.merge({
        blockMap: blockMap.merge(blocks)
    });
};
